import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import ClearIcon from '@mui/icons-material/Clear';
import "swiper/css";
import "swiper/css/pagination";
import img1 from "../../Assets/Images/cashbox_3.1.png"
import img2 from "../../Assets/Images/cashbox_4.1.png"
import img3 from "../../Assets/Images/cashbox_10.1.png"
import img4 from "../../Assets/Images/cashbox_11.1.png"
import img5 from "../../Assets/Images/cashbox_7.png"
import img6 from "../../Assets/Images/cashbox_8.png"
import img7 from "../../Assets/Images/cashbox_9.1.png"
import img8 from "../../Assets/Images/cashbox_8.1.png"
import img9 from "../../Assets/Images/cashbox_2.11.png"
// import required modules
import { Pagination, Autoplay } from "swiper";
import { Box, Modal } from "@mui/material";
import { useState } from "react";

export default function App() {
  const [open, setOpen] = React.useState(false);
  // const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const data = [
    {
      id: 1,
      img: img1,
    },
    {
      id: 2,
      img: img2,
    },
    {
      id: 3,
      img: img3,
    },
    {
      id: 4,
      img: img4,
    },
    {
      id: 5,
      img: img5,
    },
    {
      id: 6,
      img: img6,
    },
    {
      id: 7,
      img: img7,
    },
    {
      id: 8,
      img: img8,
    },
    {
      id: 9,
      img: img9,
    },
  ]
  const [clicedDevObj, setClicedDevObj] = useState([
    {
      id: 1,
      img: ""
    }
  ])
  const handleClick = (evt) => {
    setOpen(true)
    setClicedDevObj([data.find(item => (
      item.id === evt.target.id - 0
    ))])
  }
  return (
    <section className='bg-[#6656C1] py-20'>
      <div className="container mx-auto px-5 sm:px-20 lg:px-40">
        <Swiper
          slidesPerView={5}
          spaceBetween={60}
          autoplay={{
            delay: 1000,
            disableOnInteraction: false,
          }}
          pagination={{
            clickable: true,
          }}

          modules={[Autoplay, Pagination]}
          className="mySwiper cursor-pointer"
        >
          <SwiperSlide>
            <img onClick={handleClick} alt="1" id="1" className="w-[190px] h-[431px] cover" src={img1} width={180} height={431} />
          </SwiperSlide>
          <SwiperSlide>
            <img onClick={handleClick} alt="2" id="2" className="w-[190px] h-[431px] cover" src={img2} width={180} height={431} />
          </SwiperSlide>
          <SwiperSlide>
            <img onClick={handleClick} alt="3" id="3" className="w-[190px] h-[431px] cover" src={img3} width={180} height={431} />
          </SwiperSlide>
          <SwiperSlide>
            <img onClick={handleClick} alt="4" id="4" className="w-[190px] h-[431px] cover" src={img4} width={180} height={431} />
          </SwiperSlide>
          <SwiperSlide>
            <img onClick={handleClick} alt="5" id="5" className="w-[190px] h-[431px] cover" src={img5} width={180} height={431} />
          </SwiperSlide>
          <SwiperSlide>
            <img onClick={handleClick} alt="6" id="6" className="w-[190px] h-[431px] cover" src={img6} width={180} height={431} />
          </SwiperSlide>
          <SwiperSlide>
            <img onClick={handleClick} alt="7" id="7" className="w-[190px] h-[431px] cover" src={img7} width={180} height={431} />
          </SwiperSlide>
          <SwiperSlide>
            <img onClick={handleClick} alt="8" id="8" className="w-[190px] h-[431px] cover" src={img8} width={180} height={431} />
          </SwiperSlide>
          <SwiperSlide>
            <img onClick={handleClick} alt="9" id="9" className="w-[190px] h-[431px] cover" src={img9} width={180} height={431} />
          </SwiperSlide>
        </Swiper>
      </div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box onClick={handleClose} data-aos="zoom-out" className="flex relative items-start justify-center min-h-[100vh]" style={{ border: 0 }}>
          <span className="hidden sm:flex">
            <ClearIcon onClick={handleClose} className="text-white  absolute  right-10 top-10" style={{ "inlineSize": "70px", "blockSize": "70px" }} />

          </span>
          <span className=" sm:hidden">
            <ClearIcon onClick={handleClose} className="text-white  absolute  right-10 top-10" style={{ "inlineSize": "30px", "blockSize": "30px" }} />

          </span>
          {clicedDevObj && clicedDevObj?.map(item => (
            <img key={item.id} alt="9" id="9" className="w-[190px] scale-125 md:scale-[2] my-auto mx-auto h-[431px] cover" src={item.img} width={180} height={431} />
          ))}
        </Box>
      </Modal>
    </section>
  );
}
